export function loadCalendarButton(language: string) {
  return Promise.all([
    import('add-to-calendar-button'),
    import('add-to-calendar-button/styles/simple'),
    language === 'it' && import('add-to-calendar-button/i18n/it'),
  ])
}

const LIST_CSS = `
  .atcb-list-wrapper:not(.atcb-dropup, .atcb-dropoverlay) { top: calc(100% + 4px) !important; left: 0 !important;
    animation: sb-menu-down 150ms cubic-bezier(0.4, 0, 0.2, 1); }
  .atcb-list-wrapper.atcb-dropup { top: auto !important; bottom: calc(100% + 4px) !important; left: 0 !important;
    animation: sb-menu-up 150ms cubic-bezier(0.4, 0, 0.2, 1); }
  .atcb-list { min-width: 8rem; padding: 0.25rem; border-radius: 0.375rem; font-size: 0.875rem;
    box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1); }
  .atcb-list .atcb-list-item, .atcb-list .atcb-list-item:first-child, .atcb-list .atcb-list-item:last-child {
    margin: 0; padding: 0.375rem 0.5rem; border-radius: 0.125rem; line-height: 1.25rem; }
  @keyframes sb-menu-down { from { opacity: 0; transform: translateY(-0.5rem) scale(0.95); } }
  @keyframes sb-menu-up { from { opacity: 0; transform: translateY(0.5rem) scale(0.95); } }
  @media (prefers-reduced-motion: reduce) { .atcb-list-wrapper.atcb-list-wrapper { animation: none; } }
`

let listSheet: CSSStyleSheet | undefined

export function styleCalendarList(element: HTMLElement) {
  const root = element.shadowRoot
  if (!root) return

  listSheet ??= new CSSStyleSheet()
  if (!listSheet.cssRules.length) listSheet.replaceSync(LIST_CSS)
  if (!root.adoptedStyleSheets.includes(listSheet)) root.adoptedStyleSheets = [...root.adoptedStyleSheets, listSheet]
}
